/* eslint-disable implicit-arrow-linebreak */
import { useNamespace, useOkapiKy } from '@folio/stripes-core';
import { useQuery } from 'react-query';

function useBarcodeGeneral() {
  const okapiKy = useOkapiKy();
  const [namespace] = useNamespace({ key: 'generatorSettings' });

  const {
    isLoading,
    isError,
    data = {},
    refetch,
    isFetched,
    ...rest
  } = useQuery(
    [namespace],
    () =>
      okapiKy
        .get(
          'inventory-templates-configs?query=(configName==generatorSettings)',
        )
        .json(),
    { enabled: true },
  );

  return {
    isLoading,
    isFetched,
    isError,
    refetch,
    generalSettings: !isLoading ? data?.templatesConfigs[0]?.configValue : {},
    configId: !isLoading ? data?.templatesConfigs[0]?.id : undefined,
    rest,
  };
}

export default useBarcodeGeneral;
